import { Lock } from 'lucide-react';

/**
 * NoObjectivesLockedSection
 *
 * Sección bloqueada que se muestra cuando el usuario no tiene objetivos
 * en la marca activa. Incluye candado, mensaje y CTA "Crear objetivos".
 *
 * @param {function} onCreateClick - Callback al hacer clic en "Crear objetivos" (ej: navigate('/objetivos?create=true'))
 * @param {{ value: string, label: string }[]} [platformsWithoutObjectives] - Plataformas conectadas sin objetivos (ej. [{ value: 'META', label: 'Meta Ads' }]) para mensaje específico
 */
const NoObjectivesLockedSection = ({ onCreateClick, platformsWithoutObjectives = [] }) => {
  const message =
    platformsWithoutObjectives.length > 0
      ? platformsWithoutObjectives.length === 1
        ? `Creá objetivos de ${platformsWithoutObjectives[0].label} para desbloquear las optimizaciones`
        : `Creá objetivos de ${platformsWithoutObjectives.map((p) => p.label).join(' y ')} para desbloquear las optimizaciones`
      : 'Necesitás crear objetivos para desbloquear tus optimizaciones';

  return (
    <div className="backdrop-blur-xl bg-gradient-to-br from-slate-800/90 via-slate-900/90 to-indigo-900/90 border border-white/20 rounded-2xl p-4 sm:p-6 shadow-lg hover:shadow-xl hover:bg-gradient-to-br hover:from-slate-700/90 hover:via-slate-800/90 hover:to-indigo-800/90 hover:border-white/30 transition-all duration-500 ease-out text-center w-full my-8">
      <div className="relative z-10 flex flex-col items-center">
        <div className="w-16 h-16 rounded-full bg-amber-900/40 border-2 border-amber-500/50 flex items-center justify-center mb-4">
          <Lock className="w-8 h-8 text-amber-300" />
        </div>
        <h3 className="text-lg sm:text-xl font-bold text-white mb-2">
          Optimizaciones bloqueadas
        </h3>
        <div className="w-16 h-0.5 bg-gradient-to-r from-amber-500 to-orange-500 rounded-full mx-auto mb-3" />
        <p className="mb-6 text-white/70">
          {message}
        </p>
        {typeof onCreateClick === 'function' && (
          <button
            type="button"
            onClick={onCreateClick}
            className="inline-flex items-center gap-2 backdrop-blur-xl bg-gradient-to-r from-cyan-500/20 via-teal-500/20 to-cyan-600/20 border border-cyan-400/30 rounded-full px-5 py-2.5 shadow-[0_4px_14px_-2px_rgba(6,182,212,0.3),0_4px_20px_-4px_rgba(20,184,166,0.4)] hover:border-cyan-400/50 hover:scale-105 active:scale-[0.98] transition-all duration-300 text-white/90 text-sm font-medium"
          >
            Crear objetivos
          </button>
        )}
      </div>
    </div>
  );
};

export default NoObjectivesLockedSection;
